import React from 'react';
import { PageDocument, SectionInstance } from './types';
import { SectionRenderer } from './renderers';

interface Props {
  page: PageDocument | null;
  selectedSectionId: string | null;
  onSelectSection: (sectionId: string | null) => void;
  onSectionsReorder?: (sections: SectionInstance[]) => void;
}

const SiteCanvas: React.FC<Props> = ({ page, selectedSectionId, onSelectSection }) => {
  if (!page) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94a3b8' }}>
        No page selected
      </div>
    );
  }

  return (
    <div className="site-canvas" style={{ background: '#fff', minHeight: '100%' }}>
      {page.sections.map((section) => (
        <div
          key={section.section_id}
          className={`site-canvas-section ${selectedSectionId === section.section_id ? 'selected' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onSelectSection(section.section_id);
          }}
          style={{
            position: 'relative',
            outline: selectedSectionId === section.section_id ? '2px solid var(--brand-primary, #2563eb)' : '2px solid transparent',
            outlineOffset: -2,
            cursor: 'pointer',
            transition: 'outline-color 0.15s',
          }}
        >
          <SectionRenderer section={section} />
          {/* Section label overlay on hover */}
          <div className="site-canvas-section-label" style={{
            position: 'absolute', top: 4, left: 4, padding: '2px 8px',
            background: 'rgba(37,99,235,0.9)', color: '#fff',
            fontSize: '0.7rem', borderRadius: 4,
            opacity: selectedSectionId === section.section_id ? 1 : 0,
            transition: 'opacity 0.15s', pointerEvents: 'none',
          }}>
            {section.component_id}
          </div>
        </div>
      ))}
      {page.sections.length === 0 && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          height: 200, color: '#94a3b8', fontSize: '1.125rem',
        }}>
          No sections yet — add components from the left panel
        </div>
      )}
    </div>
  );
};

export default SiteCanvas;
